import { useState, useMemo, useEffect, useContext } from 'react';
import { calculatePagingStats } from '../services/pagination-service';
import { PagingContext } from '../contexts/paging-context';

export const usePaginationStats = (totalRecords) => {
  const [totalPages, setTotalPages] = useState(1);
  const [viewStartingCount, setViewStartingCount] = useState(0);
  const [viewEndingCount, setViewEndingCount] = useState(0);
  const { page, pageSize } = useContext(PagingContext);

  useEffect(() => {
    const pageStats = calculatePagingStats(page, pageSize, totalRecords);
    setTotalPages(pageStats.totalPages);
    setViewStartingCount(pageStats.viewStartingCount);
    setViewEndingCount(parseInt(pageStats.viewEndingCount, 10));
  }, [page, pageSize, totalRecords]);

  return useMemo(
    () => ({
      totalPages,
      viewStartingCount,
      viewEndingCount,
    }),
    [totalPages, viewStartingCount, viewEndingCount],
  );
};
